import { render } from "./EditInfoPanel.vue?vue&type=template&id=45b9407e&scoped=true"
import script from "./EditInfoPanel.vue?vue&type=script&lang=js"
export * from "./EditInfoPanel.vue?vue&type=script&lang=js"

import "./EditInfoPanel.vue?vue&type=style&index=0&id=45b9407e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_96a7004b96defd358d2378707b0c7ba6/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b9407e"]])

export default __exports__